import dayjs from 'dayjs';
const storeProjectId: string | null = localStorage.getItem('projectId');


export const initialValuesSalesAcceptedWizard = {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    projectId: storeProjectId,
    schedulingNotes: "",
    pdmJobCost: null,
    reviewedCost: null,
    markUp: 0,
    reviewedBy: {
        id: 0,
        value: ""
    },
    costReviewNotes: "",
    saleAcceptedDate:dayjs().format('YYYY-MM-DD')
}